var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cost-division-container",staticClass:"cost-division-container"})}
var staticRenderFns = []

export { render, staticRenderFns }